/** t139: departments, groups and people you follow; they're listed under Home in the sidebar. */
import { useQuery } from '@tanstack/react-query';
import type { NavFollowType } from '@tradeoutlet/shared';
import { api, errorMessage } from './api';
import { useWorkspaceId } from './hooks';
import { qk, queryClient } from './queryClient';
import { useUi } from './store';

export function useNavFollows() {
  const ws = useWorkspaceId();
  return useQuery({ queryKey: qk.navFollows(ws ?? ''), queryFn: () => api.navFollows(ws!), enabled: Boolean(ws), staleTime: 60_000 });
}

/** Whether you follow it, and a toggle (toast on change; the sidebar list refreshes). */
export function useFollow(type: NavFollowType, id: string | null | undefined, name: string) {
  const ws = useWorkspaceId();
  const toast = useUi(s => s.toast);
  const q = useNavFollows();
  const following = Boolean(id && (type === 'team' ? q.data?.teams.some(t => t.id === id) : q.data?.people.some(p => p.user_id === id)));
  const toggle = async () => {
    if (!ws || !id) return;
    try {
      await (following ? api.unfollow(ws, type, id) : api.follow(ws, type, id));
      await queryClient.invalidateQueries({ queryKey: qk.navFollows(ws) });
      toast(following ? `Stopped following ${name}` : `Following ${name}`, 'success');
    } catch (e) { toast(errorMessage(e), 'error'); }
  };
  return { following, toggle, ready: q.isSuccess };
}
